(function () {
  function optionInput(name, value) {
    const escaped = (window.CSS && CSS.escape) ? CSS.escape(value) : value.replace(/"/g, '\\"');
    return (
      document.querySelector('variant-selects input[value="' + escaped + '"]') ||
      document.querySelector('variant-selects select option[value="' + escaped + '"]')
    );
  }

  function selectOption(value) {
    const input = optionInput(null, value);
    if (!input) return;
    if (input.tagName === 'OPTION') {
      const select = input.closest('select');
      if (!select) return;
      select.value = value;
      Array.from(select.options).forEach((option) => {
        if (option.value === value) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bind(root) {
    const width = root.querySelector('[data-rr-width]');
    const length = root.querySelector('[data-rr-length]');
    const diameter = root.querySelector('[data-rr-diameter]');
    const label = root.querySelector('[data-rr-size-label]');
    const colorField = root.querySelector('[data-rr-color]');

    function updateLabel() {
      if (!label) return;
      if (diameter) {
        label.textContent = diameter.value;
        return;
      }
      if (width && length) {
        const widthText = width.options[width.selectedIndex] ? width.options[width.selectedIndex].text.trim() : width.value;
        const lengthText = length.options[length.selectedIndex] ? length.options[length.selectedIndex].text.trim() : length.value;
        label.textContent = widthText + ' × ' + lengthText;
      }
    }

    function selectedSizeValue() {
      const checked = document.querySelector('variant-selects .rr-custom-size__hidden-size input:checked');
      if (checked) return checked.value;
      return '';
    }

    function availableSizes() {
      return Array.from(document.querySelectorAll('variant-selects .rr-custom-size__hidden-size input:not(.disabled)'));
    }

    function applySizeValue(sizeValue) {
      if (!sizeValue) return;
      if (sizeValue.indexOf('diameter') !== -1 && diameter) {
        if (Array.from(diameter.options).some((option) => option.value === sizeValue)) diameter.value = sizeValue;
        return;
      }
      if (!width || !length) return;
      const parts = sizeValue.split(' × ');
      if (parts[0] && Array.from(width.options).some((option) => option.value === parts[0])) width.value = parts[0];
      if (parts[1] && Array.from(length.options).some((option) => option.value === parts[1])) length.value = parts[1];
    }

    function syncSize() {
      let next = diameter ? diameter.value : (width && length ? width.value + ' × ' + length.value : '');
      const input = next ? optionInput(null, next) : null;
      if (!input || input.classList.contains('disabled')) {
        const first = availableSizes()[0];
        if (first) {
          applySizeValue(first.value);
          next = first.value;
        }
      }
      if (next && next !== selectedSizeValue()) selectOption(next);
      updateLabel();
    }

    diameter?.addEventListener('change', syncSize);
    width?.addEventListener('change', syncSize);
    length?.addEventListener('change', syncSize);
    syncSize();

    root.querySelectorAll('[data-rr-color-option]').forEach((input) => {
      input.addEventListener('change', function () {
        if (colorField && input.checked) colorField.value = input.value;
      });
    });
  }

  document.querySelectorAll('[data-rr-custom-size]').forEach(bind);
})();
